import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class AnalyticsFilterurlService {
  constructor() { }

  filterTrackingUrlParams(inputHref: string): string {
    const fullUrl = new URL(inputHref);

    // Hier nun spezielle Tracking Parameter raus, siehe https://confluence.datev.de/display/DMI/Tracking+Parameter+von+extern
    fullUrl.searchParams.delete('fbclid'); // Facebook
    fullUrl.searchParams.delete('gclid'); // Google
    fullUrl.searchParams.delete('ttclid'); // TikTok
    fullUrl.searchParams.delete('msclkid'); // Microsoft
    fullUrl.searchParams.delete('_gl'); // Google Analytics
    fullUrl.searchParams.delete('_ga'); // Google Analytics
    fullUrl.searchParams.delete('dcal_hint'); // DCAL Login Status, nicht benötigt in Auswertungen
    fullUrl.searchParams.delete('dcal_reqid'); // DCAL Login Token

    fullUrl.searchParams.delete('stat_Mparam');
    fullUrl.searchParams.delete('_hsenc');
    fullUrl.searchParams.delete('_hsmi');
    fullUrl.searchParams.delete('utm_campaign');
    fullUrl.searchParams.delete('utm_target');
    fullUrl.searchParams.delete('utm_content');
    fullUrl.searchParams.delete('utm_medium');
    fullUrl.searchParams.delete('utm_author');

    return fullUrl.toString();
  }

}
